import React from 'react';
import { Reveal } from '../ui/Reveal';

const DividerText = () => {
  return (
    <section className="bg-charcoal-900 py-16 border-b border-white/5">
      <div className="container mx-auto px-6 text-center">
        <Reveal>
          <h2 className="text-gold-500 text-xl md:text-2xl font-semibold tracking-wide">
            Delivering accurate, defensible, lender-ready valuation reports across the East Coast.
          </h2>
        </Reveal>
      </div>
    </section>
  );
};

export default DividerText;